import styled from 'styled-components';
import { SYS_SPACE_FIXED_600, SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_SM, SYS_SPACE_FIXED_200, } from '@oneaudi/unified-web-common';
export const StyledTechnicalSection = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_RELATIVE_SM};

  > div {
    margin-top: ${SYS_SPACE_FIXED_600};
    &:first-child {
      margin-top: 0;
    }
  }

  .value-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    word-break: break-word;
    flex: 1;
  }

  .technical-key {
    margin-top: ${SYS_SPACE_FIXED_150};
  }

  .technical-value {
    margin-top: ${SYS_SPACE_FIXED_150};
    margin-bottom: ${SYS_SPACE_FIXED_200};
  }
`;
